import { genFlashcardsFn, genQuizFn, genPlanFn } from "./study.functions";

export interface GeneratedFlashcard { front: string; back: string }
export interface QuizQuestion { question: string; choices: string[]; correctIndex: number; explanation: string }

export const generateFlashcards = (concept: string, count = 5, language = "en") =>
  genFlashcardsFn({ data: { concept, count, language } });

export const generateQuiz = (concept: string, count = 5, language = "en") =>
  genQuizFn({ data: { concept, count, language } });

export const generatePlan = (title: string, exam_date: string | null, concepts: string[], language = "en") =>
  genPlanFn({ data: { title, exam_date, concepts, language } });